<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="structure-next"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="paragraph-style"><span class="qoutes">“</span><span class="char-style-override">A</span>  man who views the world the same at fifty as he  did at twenty has wasted thirty years of his life.”</p>
<p class="chapsoy-title"> </p>
<p class="right">- Muhammad Ali</p>
<div class="calibre1" id="calibre_pb_2"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NGJobHacks_split_002.vue?f6913b88